<script setup lang="ts">
import EventActivitiesCaroussel from "@/views/event-activities/components/EventActivitiesCaroussel.vue";
import {defineProps} from "vue";
const props = defineProps(
    {
      carouselItems:[]
    }
  )

</script>

<template>
  <div class="impx-slide-container hp3 uk-padding uk-padding-remove-horizontal uk-padding-remove-bottom uk-background-fixed uk-background-center-center uk-height-1-1">
    <div class="impx-overlay dark"></div>
    <div class="uk-container uk-margin-top impx-margin-top-small">
      <event-activities-caroussel :carrousel-element="props.carouselItems"></event-activities-caroussel>
    </div>
  </div>

</template>

<style scoped>

</style>